import Joyride, { type CallBackProps } from "react-joyride";
import { joyrideLocale, joyrideStyles } from "./joyrideConfig";
import { leaveRequestFormTourSteps } from "./leaveRequestFormTourSteps";
import { useLeaveTour } from "./useLeaveTour";

const TOUR_STORAGE_KEY = "hr-leave-request-form-tour-completed";

type LeaveRequestFormTourProps = {
  run: boolean;
  onCallback: (data: {
    status?: string;
    type?: string;
    index?: number;
  }) => void;
};

export function LeaveRequestFormTour({
  run,
  onCallback,
}: LeaveRequestFormTourProps) {
  const handleCallback = (data: CallBackProps) => {
    onCallback({ status: data.status, type: data.type, index: data.index });
  };

  return (
    <Joyride
      steps={leaveRequestFormTourSteps}
      run={run}
      continuous
      showProgress
      showSkipButton
      callback={handleCallback}
      locale={joyrideLocale}
      styles={joyrideStyles}
      scrollToFirstStep
      scrollOffset={24}
      scrollDuration={300}
    />
  );
}

export function useLeaveRequestFormTour() {
  return useLeaveTour(TOUR_STORAGE_KEY);
}
